import _ from 'lodash';
import config from '../package.json';

export const getLuckydrawTokenUrl = (state: {}) => {
  const url = _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.${config.profileApiModuleName}.luckydrawTokenEndpoint.url`,
    '',
  );
  return url;
};

export const getLuckydrawLandingDeeplink = (state: {}) => {
  const deeplink = _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.${config.profileApiModuleName}.luckydrawLandingEndpoint.deepLink`,
    '',
  );
  return deeplink;
};

export const getErrorMessageCode = (state: {}) => {
  const code = _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.${config.profileApiModuleName}.errorMessageCode`,
    '',
  );
  return code;
};

export const getLuckydrawToken = (state: any): string => {
  const token = _.get(
    state,
    `hk-emma-web-core/${config.id}.luckydrawToken`,
    '',
  );
  return token;
};
